<template>
  <div class="">

    <div
      class="mb-3"
      v-if="hasDays(businessHours.week_days)"
    >
      <div
        class=""
        v-for="(hours,index) in businessHours.week_days"
        :key="index"
      >
        <div class="text-capitalize font-weight-bold h6 my-2">{{index}}</div>
        <div
          class=""
          v-for="(times,index2) in businessHours.week_days[index]"
          :key="index2"
        >
          <div v-if="times.isOpen && (times.open && times.close)">{{ convertTime(times.open) }} - {{ convertTime(times.close) }}</div>
          <div v-if="!times.isOpen">Closed</div>
        </div>
      </div>
    </div>
    <div
      class="mb-3"
      v-if="hasDays(businessHours.holiday_days)"
    >
      <hr>
      <div
        class=""
        v-for="(hours,index) in businessHours.holiday_days"
        :key="index"
      >
        <div class="text-capitalize font-weight-bold h6 my-2">{{index}}</div>
        <div
          class=""
          v-for="(times,index2) in businessHours.holiday_days[index]"
          :key="index2"
        >
          <div v-if="times.isOpen && (times.open && times.close)">{{ convertTime(times.open) }} - {{ convertTime(times.close) }}</div>
          <div v-if="!times.isOpen">Closed</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment-timezone";
export default {
  methods: {
    convertTime: function (value) {
      return moment.utc(value, "HH:mm:ss").format("h:mm a");
    },
    hasDays: function (value) {
      return Object.keys(value).length;
    },
  },
  computed: {
    businessHours: function () {
      const hours = JSON.parse(this.rawMenu.user.business_hours);
      return hours;
    },
  },
};
</script>
